import { query, destroy, post, put } from '@/services/api/backendGateway'

const CATEGORY_API = '/category/'

export async function fetchUserCategories(userId = null) {
  const params = {}
  if (userId !== null && userId !== undefined) {
    params.user = userId
  }
  return (await query(CATEGORY_API, params)) || []
}

export async function fetchCategoryById(categoryId) {
  return query(CATEGORY_API, { id: categoryId })
}

export function createCategory({ label, userId, color = undefined }) {
  const body = { label, user: userId }
  if (color !== undefined) body.color = color
  return post(CATEGORY_API, body)
}

export function updateCategory({ id, label, userId, color = undefined, create = 'False' }) {
  const body = { id, label, user: userId, create }
  if (color !== undefined) body.color = color
  return put(CATEGORY_API, body)
}

export function deleteCategoryById(categoryId) {
  return destroy(CATEGORY_API, { id: categoryId })
}
